module.exports = __webpack_public_path__ + "media/clara.bed0ac89.mp3";